let apiUrl;
if (process.env.REACT_APP_API_URL_LOCAL) {
  //   apiUrl = process.env.REACT_APP_API_URL_LOCAL;
  apiUrl = "https://api.fincalc.io";
} else {
  apiUrl = "https://api.fincalc.io";
}

export default apiUrl;
